import React from 'react';

interface ConfirmGenerateModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
  success?: boolean;
}

const ConfirmGenerateModal: React.FC<ConfirmGenerateModalProps> = ({ open, onCancel, onConfirm, loading = false, success = false }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-2"
      tabIndex={-1}
      aria-modal="true"
      role="dialog"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl shadow-xl p-6 flex flex-col items-center relative min-w-[400px] max-w-[95vw] w-full outline-none"
        onClick={e => e.stopPropagation()}
        style={{ minWidth: 400, maxWidth: 400 }}
        tabIndex={0}
      >
        {success ? (
          <div className="flex flex-col items-center justify-center w-full">
            <svg width="64" height="64" fill="none" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="12" fill="#22c55e" />
              <path d="M7 13l3 3 7-7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div className="text-green-600 text-xl font-semibold mt-4 mb-4">Document generated!</div>
            <button
              className="w-full bg-[#0B4BB6] text-white font-plus-jakarta font-bold text-[15px] py-2 px-8 rounded-full hover:bg-[#23235a] transition-colors"
              style={{ borderRadius: 60 }}
              onClick={onCancel}
            >
              OK
            </button>
          </div>
        ) : (
          <>
            {loading && !success && (
              <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-90 rounded-2xl">
                <svg className="animate-spin h-12 w-12 text-[#0B4BB6]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#0B4BB6" strokeWidth="4" />
                  <path className="opacity-75" fill="#0B4BB6" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                <div className="text-[#0B4BB6] text-lg font-semibold mt-4">Generating document...</div>
              </div>
            )}
            <div className="flex flex-col items-center gap-2 mt-2 mb-4">
              <svg width="48" height="48" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="12" fill="#F59E42" />
                <path d="M12 8v4" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="16" r="1" fill="#fff" />
              </svg>
              <div className="text-[#B45309] text-lg font-semibold mt-2 text-center">
                Warning: Do you want to generate the document?
              </div>
              <div className="text-[#485D7D] text-sm text-center mt-1">
                This action cannot be undone. Once generated, the document will be finalized and cannot be modified.
              </div>
            </div>
            <div className="flex flex-row gap-4 w-full mt-4">
              <button
                className="flex-1 bg-[#7C8B9D] text-white font-plus-jakarta font-bold text-[15px] py-2 px-5 rounded-full hover:bg-[#485D7D] transition-colors"
                style={{ borderRadius: 60 }}
                onClick={onCancel}
                disabled={loading || success}
              >
                Cancel
              </button>
              <button
                className="flex-1 bg-[#0B4BB6] text-white font-plus-jakarta font-bold text-[15px] py-2 px-5 rounded-full hover:bg-[#23235a] transition-colors"
                style={{ borderRadius: 60 }}
                onClick={onConfirm}
                disabled={loading || success}
              >
                Generate
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmGenerateModal; 